/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ITable } from '../interfaces/interfaces';
import { IpEmailObjectStoreService } from '../services/internals/ip-email-object-store/ip-email-object-store.service';

@Component({
  selector: 'ip-table-settings',
  template: `
    <div class="group" [class.three]="isEven()">
      <mat-form-field appearance="outline" *ngIf="hasOwnProperty('rows')">
        <mat-label i18n="Table Settings|Change Table Rows">Rows</mat-label>
        <input
          matInput
          [(ngModel)]="table.rows"
          type="number"
          min="0"
          step="1"
          (input)="markForCheck()"
          i18n-placeholder
          placeholder="Table Settings|Change Table Rows"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="hasOwnProperty('columns')">
        <mat-label i18n="Table Settings|Change Table Columns">Columns</mat-label>
        <input
          matInput
          [(ngModel)]="table.columns"
          type="number"
          min="0"
          step="1"
          (input)="markForCheck()"
          i18n-placeholder
          placeholder="Table Settings|Change Table Columns"
        />
      </mat-form-field>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
      mat-form-field {
        width: 100%;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableSettingsComponent {
  @Input() table: ITable;

  constructor(private emailObject: IpEmailObjectStoreService) {}

  markForCheck() {
    this.emailObject.markForCheck();
  }

  isEven(): boolean {
    return Object.keys(this.table).length % 2 === 0;
  }

  hasOwnProperty(property: string): boolean {
    return this.table.hasOwnProperty(property);
  }
}
